




































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import GoodsSelect from '@/components/goods-select/index.vue'
import ProductRecommendApi from '@/api/goods/recommend/index'
import AbpBase from '@/lib/abpbase'
import appconst from '@/lib/appconst'
@Component({
  components: {
    GoodsSelect,
  },
})
export default class ProductRecommend extends AbpBase {
  loading = false
  uploadUrl = ''
  isCheckAll: boolean = false
  selectedIds: any = new Set()
  exporting: boolean = false
  columns = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '商品名称',
      key: 'productName',
    },
    {
      title: '图片',
      key: 'pictureUrl',
      slot: 'pictureUrl',
      width: 100,
    },
    {
      title: '货号',
      key: 'productCode',
      width: 140,
    },
    {
      title: '排序',
      key: 'displayOrder',
      slot: 'displayOrder',
      width: 100,
    },
    {
      title: '操作',
      key: 'action',
      slot: 'action',
      width: 100,
    },
  ]
  data = []

  get selectedItems() {
    return this.data.map((t) => t.productId)
  }
  mounted() {
    this.uploadUrl = `${appconst.remoteServiceBaseUrl}/api/productManagement/recommendedProduct/excel/RecoUpload`
    this.loadData()
  }
  loadData() {
    this.loading = true
    ProductRecommendApi.getAll().then((res) => {
      this.data = res.data
      this.loading = false
    })
  }
  onDisplayOrderChange(id, val) {
    ProductRecommendApi.updateDisplayOrder(id, val).then((res) => {
      this.$Message.success('修改成功')
      this.loadData()
    })
  }
  deleteItem(id: string) {
    ProductRecommendApi.deleteRecommendProduct(id).then((res) => {
      this.$Message.success('删除成功')
      this.loadData()
    })
  }
  onChange(e) {
    console.log(e)
    var input = e.map((t) => {
      return {
        productId: t.id,
        pictureUrl: t.pictureUrl,
        productName: t.name,
        productCode: t.code,
        displayOrder: 0,
      }
    })
    ProductRecommendApi.create(input).then((res) => {
      this.loadData()
    })
  }
  handleTableAllCancel() {
    this.isCheckAll = false
    let data = (this.$refs.selection as any).data
    data.forEach((item) => {
      if (this.selectedIds.has(item.id)) {
        this.selectedIds.delete(item.id)
      }
    })
  }
  handleTableAll(selection) {
    this.isCheckAll = true
    selection.forEach((item) => {
      this.selectedIds.add(item.id)
    })
  }
  handleSelect(slection, row) {
    this.selectedIds.add(row.id)
  }
  handleCancel(slection, row) {
    this.selectedIds.delete(row.id)
  }
  handleSelectChange(selection) {
    this.isCheckAll = selection.length === this.data.length
  }

  handleSelectAll() {
    if (!this.data.length) return
    ;(this.$refs.selection as any).selectAll(!this.isCheckAll)
  }
  deleteSelectd() {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      console.log('执行删除')
      this.$Modal.confirm({
        title: '批量删除商品规格',
        content: `是否删除已选中的商品规格?`,
        onOk: () => {
          console.log('点了确定了', selection)
          let ids = selection.map((item) => item.id)
          ProductRecommendApi.deleteProductRecommond(ids).then((res) => {
            this.$Message.success('删除成功')
            this.loadData()
          })
        },
      })
    } else {
      this.$Notice.warning({
        title: '请先选择商品',
      })
    }
  }
  /**
   * 导入商品
   */
  uploadSuccess(res) {
    this.$Message.success('上传文件成功，导入比较耗时，请稍后刷新查看结果')
    // this.loadData();
    console.log(res)
    this.loadData()
  }
  /**
   * 导出excel表格
   */
  exportExcel() {
    this.exporting = true
    // 调用接口
    ProductRecommendApi.exportProductRecommendFile()
      .then((res) => {
        console.log(res)
        this.exporting = false
        this.download(res.data)
      })
      .catch((err) => {
        this.exporting = false
      })
  }
  download(data) {
    if (!data) {
      return
    }
    let url = window.URL.createObjectURL(new Blob([data]))
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', '商品推荐.xlsx')

    document.body.appendChild(link)
    link.click()
  }
}
